/* eslint-disable prettier/prettier */
import React from 'react';
import { Activity } from '../../types/schedule.types';
import { useScheduler } from '../../hooks/useScheduler';
import { useActivityFilter } from '../../hooks/useActivityFilter';
import { useScheduleActivities } from '../../hooks/useScheduleActivities';
import PeriodNavigator from '../scheduler/PeriodNavigator';
import ViewModeToggle from './ViewModeToggle';
import ActivityTypeFilter from './ActivityTypeFilter';
import MonthlySchedule from './MonthlySchedule';
import WeekGrid from './WeekGrid';
import styles from '../../styles/Schedule/WeeklySchedule.module.css';

interface ScheduleCalendarProps {
	onActivityClick?: (activity: Activity) => void;
}

const ScheduleCalendar: React.FC<ScheduleCalendarProps> = ({
	onActivityClick,
}) => {
	const {
		state,
		activeRange,
		setViewMode,
		openCalendar,
		closeCalendar,
		selectWeek,
		selectMonthRange,
		navigatePrev,
		navigateNext,
		setCalendarView,
		navigateMonth,
		selectMonth,
		selectYear,
	} = useScheduler();

	const { activeFilters, toggleFilter, clearFilters } = useActivityFilter();
	const { activitiesByDate, loading, error } = useScheduleActivities(
		activeRange,
		activeFilters,
		state.viewMode
	);

	return (
		<div className={styles.container}>
			<div className={styles.topBar}>
				<div className={styles.leftControls}>
					<PeriodNavigator
						viewMode={state.viewMode}
						selectedWeek={state.selectedWeek}
						selectedMonth={state.selectedMonth}
						currentMonth={state.currentMonth}
						currentYear={state.currentYear}
						isCalendarOpen={state.isCalendarOpen}
						calendarView={state.calendarView}
						onPrev={navigatePrev}
						onNext={navigateNext}
						onOpenCalendar={openCalendar}
						onCloseCalendar={closeCalendar}
						onSelectWeek={selectWeek}
						onSelectMonthRange={selectMonthRange}
						onNavigateMonth={navigateMonth}
						onSetCalendarView={setCalendarView}
						onSelectMonth={selectMonth}
						onSelectYear={selectYear}
					/>

					<ViewModeToggle
						viewMode={state.viewMode}
						onChange={setViewMode}
					/>
				</div>

				<div className={styles.filterSection}>
					<ActivityTypeFilter
						activeFilters={activeFilters}
						onToggle={toggleFilter}
					/>
				</div>
			</div>

			<div className={styles.divider} />

			{error && <p className={styles.error}>{error}</p>}

			{state.viewMode === 'week' ? (
				<WeekGrid
					selectedWeek={state.selectedWeek}
					activitiesByDate={activitiesByDate}
					loading={loading}
					onActivityClick={onActivityClick}
				/>
			) : (
				<MonthlySchedule
					selectedMonth={state.selectedMonth}
					activitiesByDate={activitiesByDate}
					loading={loading}
					onActivityClick={onActivityClick}
				/>
			)}
		</div>
	);
};

export default ScheduleCalendar;
